/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import Table from '../components/table/table';
import ModalComponent from '../components/modal';

import {
  getSolicitations,
  getCsvSolicitationsReport,
  updateStatusSolicitations,
} from '../app/store/actions/solicitations';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';
import Notification from '../components/notifications';

class RegisterSolicitaionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      showModal: false,
      modal: {},
      orderBy: 'DESC',
      field: 'createdAt',
      searchType: '0',
      forcingCompletion: false,
      cancel: false,
      showError: false,
      errorMessage: '',
    };
  }

  componentDidMount() {
    this.searcSolicitations();
  }

  searcSolicitations = async () => {
    await this.props.searcSolicitations(this.state.searchType);
    this.setState({ page: 1 });
  };

  setFilterType = async (orderFieldValue) => {
    await this.setState({ searchType: orderFieldValue });
    await this.searcSolicitations();
  };

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
  };

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
  };

  showPermissionWarning = (message) => {
    this.setState({ showError: true, errorMessage: message });

    setTimeout(() => {
      this.setState({ showError: false, errorMessage: '' });
    }, 5000);
  };

  notification = async (classe, message) => {
    this.setState({ showError: true, message, classe });
    setTimeout(() => {
      this.setState({ showError: false });
    }, 5000);
  };

  Pagination = () => {
    const { solicitations } = this.props;
    const { page, search } = this.state;
    const limit = {};

    // eslint-disable-next-line array-callback-return
    const adminListOrderedUsers = (solicitations || []).sort(
      (first, second) => {
        if (
          this.state.field === 'phone'
          || this.state.field === 'cnpj'
          || this.state.field === 'isMobile'
        ) {
          if (this.state.orderBy === 'DESC') {
            if (first[`${this.state.field}`] > second[`${this.state.field}`]) {
              return -1;
            }
            if (first[`${this.state.field}`] < second[`${this.state.field}`]) {
              return 1;
            }
          }
          if (first[`${this.state.field}`] > second[`${this.state.field}`]) {
            return 1;
          }
          if (first[`${this.state.field}`] < second[`${this.state.field}`]) {
            return -1;
          }
        } else if (
          this.state.field === 'createdAt'
          || this.state.field === 'birthday'
        ) {
          if (this.state.orderBy === 'DESC') {
            if (
              moment(first[`${this.state.field}`]).isAfter(
                second[`${this.state.field}`],
              )
            ) {
              return -1;
            }
            if (
              moment(first[`${this.state.field}`]).isBefore(
                second[`${this.state.field}`],
              )
            ) {
              return 1;
            }
          }
          if (
            moment(first[`${this.state.field}`]).isAfter(
              second[`${this.state.field}`],
            )
          ) {
            return 1;
          }
          if (
            moment(first[`${this.state.field}`]).isBefore(
              second[`${this.state.field}`],
            )
          ) {
            return -1;
          }
        } else {
          if (this.state.orderBy === 'DESC') {
            if (
              first[`${this.state.field}`].toLocaleLowerCase()
              > second[`${this.state.field}`].toLocaleLowerCase()
            ) {
              return -1;
            }
            if (
              first[`${this.state.field}`].toLocaleLowerCase()
              < second[`${this.state.field}`].toLocaleLowerCase()
            ) {
              return 1;
            }
          }
          if (
            first[`${this.state.field}`].toLocaleLowerCase()
            > second[`${this.state.field}`].toLocaleLowerCase()
          ) {
            return 1;
          }
          if (
            first[`${this.state.field}`].toLocaleLowerCase()
            < second[`${this.state.field}`].toLocaleLowerCase()
          ) {
            return -1;
          }
        }
      },
    );

    const tableData = (adminListOrderedUsers || []).map((row, index) => ({
      key: index,
      email: row.email,
      cnpj: row.cnpj,
      name: row.name,
      ...(this.props.companyTag === 'chile' && { segment: row.segment || '' }),
      firstName: row.firstName,
      lastName: row.lastName,
      birthday: moment(row.birthday).format('DD/MM/YYYY'),
      phone: row.phone,
      city: row.city,
      province: row.province,
      address: row.address,
      state: row.state,
      isMobile: row.isMobile === false ? 'Web' : 'APP',
      companyOrDependent: row.companyOrDependent,
      personalDocument: row.personalDocument,
      propertyCredential: row.propertyCredential,
      pending: (row.registrationInSphere && (row.status >= 2) ? '' : 
        (row.registrationInSphere && row.pending === 'checkbuy' ? I18n.t('pendingCheckbuy') : 
          (!row.registrationInSphere && row.pending === 'sphere' ? I18n.t('pendingSphere') : 'default value'))),
      serviceBranch: row.sphereLocations && row.sphereLocations.name || '',
      createdAt: moment(row.createdAt).format('DD/MM/YYYY'),
      action:
        row.status < 1
        && (row.userRegistrationInCheckbuy ? (
          <button
            type="button"
            className="btn btn-green btn-can-approve"
            onClick={() => this.endingModal(row)}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {I18n.t('toConfirm')}
          </button>
        ) : row.registrationInSphere || row.customerRegistrationInCheckbuy ? (
          <button
            type="button"
            className="btn btn-success btn-can-approve"
            onClick={() => this.activeModal(row)}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Translate value="ToFinish" />
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-warning btn-can-approve"
            onClick={() => this.waitingModal(row)}
          >
            <Translate value="pending" />
          </button>
        )),
      cancel: row.status < 1 && (
        <button
          type="button"
          className="btn btn-danger btn-can-approve"
          onClick={() => this.cancelModal(row)}
        >
          {I18n.t('cancel')}
        </button>
      ),
    }));
    if (search !== '') {
      const tempTableData = tableData.filter(
        el => el.name.toLowerCase().includes(search.toLowerCase())
          || el.email.toLowerCase().includes(search.toLowerCase())
          || el.firstName.toLowerCase().includes(search.toLowerCase())
          || el.cnpj.toString().includes(search),
      );

      if (tempTableData.length <= this.state.limit) {
        return { data: tempTableData, count: tempTableData.length };
      }
      if (page > 1) {
        limit.limitMax = 20 * page;
        limit.limitMin = 20 * page - 20;
      } else {
        limit.limitMax = 20;
        limit.limitMin = 0;
      }
      return {
        data: tempTableData.slice(limit.limitMin, limit.limitMax),
        count: tempTableData.length,
      };
    }

    if (page > 1) {
      limit.limitMax = 20 * page;
      limit.limitMin = 20 * page - 20;
    } else {
      limit.limitMax = 20;
      limit.limitMin = 0;
    }
    return {
      data: tableData.slice(limit.limitMin, limit.limitMax),
      count: tableData.length,
    };
  };

  waitingModal = async (item) => {
    await this.setState({
      forcingCompletion: true,
      selectItemToDelete: item,
      showModal: true,
      modal: {
        title: I18n.t('pending'),
        body: I18n.t('waitingSphere'),
        titleCancelButton: I18n.t('ok'),
        okBtn: I18n.t('forceCompletion'),
        action: true,
      },
    });
  };

  cancelModal = async (item) => {
    await this.setState({
      cancel: true,
      showModal: true,
      selectItemToDelete: item,
      modal: {
        title: I18n.t('cancel'),
        body: I18n.t('cancelThisRequest'),
        okBtn: I18n.t('yes'),
        titleCancelButton: I18n.t('no'),
        action: true,
      },
    });
  };

  endingModal = async (item) => {
    await this.setState({
      selectItemToDelete: item,
      showModal: true,
      forcingCompletion: true,
      modal: {
        title: I18n.t('toConfirm'),
        body: I18n.t('solicitationCompleted'),
        okBtn: I18n.t('ok'),
        titleCancelButton: '',
        action: true,
      },
    });
  };

  activeModal = async (item) => {
    await this.setState({
      selectItemToDelete: item,
      showModal: true,
      modal: {
        title: I18n.t('newUsers'),
        body: I18n.t('confirmContactClient'),
        okBtn: I18n.t('confirm'),
        titleCancelButton: '',
        action: true,
      },
    });
  };

  validStatusSolicitation = async (selectItemToDelete) => {
    if (selectItemToDelete.client) {
      const { client } = selectItemToDelete;

      if (client && client.clientData && client.contacts.length > 0) {
        return true;
      }

      return false;
    }
  };

  modalActions = async () => {
    const { selectItemToDelete, forcingCompletion, cancel } = this.state;
    if (selectItemToDelete) {
      if (
        this.validStatusSolicitation(selectItemToDelete)
        && !forcingCompletion
        && !cancel
      ) {
        try {
          history.push({
            pathname: ROUTES.FORM,
            state: selectItemToDelete,
            client: {
              ...selectItemToDelete.client.clientData,
              sphereClient: selectItemToDelete.client,
            },
            screenComming: 'users',
            screenBack: 'solicitations',
          });
        } catch (error) {}
      } else if (selectItemToDelete && (forcingCompletion || cancel)) {
        await this.props.updateStatusSolicitations(
          selectItemToDelete.id,
          cancel ? 3 : 2,
        );
        await this.searcSolicitations();
      }
    }
    await this.setState({
      showModal: false,
      forcingCompletion: false,
      cancel: false,
    });
  };

  renamePageRegister = (item) => {
    item = Number(item);
    switch (item) {
      case 0:
        return `${I18n.t('allSolicitations')}`;
      case 1:
        return I18n.t('pendingSphere');
      case 2:
        return I18n.t('pendingCheckbuy');
      case 3:
        return I18n.t('processed');
      case 4:
        return I18n.t('canceled');
      default:
        return '';
    }
  }

  render() {
    const {
      limit,
      page,
      modal,
      showModal,
      searchType,
      showError,
      errorMessage,
    } = this.state;

    const tableHeader = [
      { key: 'email', value: I18n.t('email') },
      { key: 'cnpj', value: I18n.t('cnpj') },
      { key: 'name', value: I18n.t('company') },
      this.props.companyTag === 'chile' && {
        key: 'segment',
        value: I18n.t('segment'),
      },
      { key: 'firstName', value: I18n.t('name') },
      { key: 'lastName', value: I18n.t('lastName') },
      { key: 'birthday', value: I18n.t('birthday') },
      { key: 'phone', value: I18n.t('phone') },
      { key: 'city', value: I18n.t('city') },
      { key: 'state', value: I18n.t('state') },
      { key: 'province', value: I18n.t('province') },
      { key: 'address', value: I18n.t('address') },
      searchType < 1 && { key: 'pending', value: I18n.t('pending') },
      searchType < 3 && { key: 'serviceBranch', value: I18n.t('preferencesBranch') },
      { key: 'createdAt', value: I18n.t('requestDate') },
      this.props.companyTag === 'chile'
        && searchType < 3 && { key: 'cancel', value: I18n.t('cancel') },
      searchType < 3 && { key: 'action', value: I18n.t('action') },
    ];

    const { data = [], count = 0 } = this.Pagination();

    const tableButtons = (
      <React.Fragment>
        <button
          onClick={() => this.props.getCsvSolicitationsReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={modal.title}
          body={modal.body}
          visible={showModal}
          closeModal={() => this.setState({
            showModal: false,
            forcingCompletion: false,
            cancel: false,
          })
          }
          titleOkButtoon={modal.okBtn}
          titleCancelButton={
            modal.titleCancelButton ? modal.titleCancelButton : undefined
          }
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel={modal.action}
          confirmModal={() => (modal.action
            ? this.modalActions()
            : this.setState({ showModal: false }))
          }
        />

        <Table
          title={`${I18n.t('registerSolicitation')} - ${this.renamePageRegister(searchType)}`}
          buttons={tableButtons}
          header={tableHeader}
          lines={data}
          page={page}
          perPage={limit}
          count={count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
          alternativeExtras
          extras={(
            <React.Fragment>
              <select
                onChange={e => this.setFilterType(e.target.value)}
                style={{ width: 'max-Content', height: '34px' }}
                className="float-right custom-select"
                value={searchType}
                disabled={false}
                required
              >
                <option value="0">{I18n.t('allSolicitations')}</option>
                <option value="1">{I18n.t('pendingSphere')}</option>
                <option value="2">{I18n.t('pendingCheckbuy')}</option>
                <option value="3">{I18n.t('processed')}</option>
                <option value="4">{I18n.t('canceled')}</option>
              </select>
            </React.Fragment>
          )}
        />
        {showError && <Notification classe="danger" message={errorMessage} />}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searcSolicitations: searchType => dispatch(getSolicitations(searchType)),
  getCsvSolicitationsReport: () => dispatch(getCsvSolicitationsReport()),
  updateStatusSolicitations: (solicitationId, solicitationStatus) => dispatch(updateStatusSolicitations(solicitationId, solicitationStatus)),
});

const mapStateToProps = state => ({
  solicitations: state.solicitations.solicitations,
  companyTag: state.settings && state.settings.companyTag,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisterSolicitaionPage);
